import { render, staticRenderFns } from "./SalesSummary.vue?vue&type=template&id=60ef613b&scoped=true&"
import script from "./SalesSummary.vue?vue&type=script&lang=js&"
export * from "./SalesSummary.vue?vue&type=script&lang=js&"
import style0 from "./SalesSummary.vue?vue&type=style&index=0&id=60ef613b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60ef613b",
  null
  
)

export default component.exports